import { type VariantProps, cva } from 'class-variance-authority';
import React, { type ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

const sidePanelContent = cva('w-full text-body-l p-xl');

type PanelContentElement = React.ElementRef<'div'>;
type SidePanelContentProps = VariantProps<typeof sidePanelContent> & {
  children: ReactNode;
  shouldFillContainer?: boolean;
};

/**
 * Wrapper for the content section of SidePanel.
 */
// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const Content = React.forwardRef<
  PanelContentElement,
  SidePanelContentProps
>(({ shouldFillContainer = true, ...props }, forwardedRef) => {
  return (
    <div
      {...props}
      className={twMerge(
        sidePanelContent(),
        shouldFillContainer && 'flex-1 overflow-y-auto',
      )}
      ref={forwardedRef}
    />
  );
});

Content.displayName = 'SidePanelContent';
